module.exports = __webpack_public_path__ + "img/highlights.2b4ee8a5.jpeg";